import React, { useEffect, useState } from 'react';
import './StatsSection.css';

const StatsItem = ({ icon, title, value, suffix = '' }) => {
  const [displayValue, setDisplayValue] = useState(0);
  
  useEffect(() => {
    // Animate number counting up
    const duration = 2000;
    const steps = 60;
    const stepValue = value / steps;
    let current = 0;
    
    const timer = setInterval(() => {
      current += stepValue;
      if (current >= value) {
        setDisplayValue(value);
        clearInterval(timer);
      } else {
        setDisplayValue(Math.floor(current));
      }
    }, duration / steps);
    
    return () => clearInterval(timer);
  }, [value]);
  
  return (
    <div className="stats-item">
      <div className="stats-icon">{icon}</div>
      <div className="stats-value-container">
        <span className="stats-value">{displayValue.toLocaleString()}</span>
        {suffix && <span className="stats-suffix">{suffix}</span>}
      </div>
      <h3 className="stats-title">{title}</h3>
    </div>
  );
};

const StatsSection = ({ stats }) => {
  return (
    <section className="stats-section-wrapper">
      <h2 className="stats-section-heading">Platform Metrics</h2>
      <p className="stats-section-subheading">Real-time data from our growing marketplace</p>
      
      <div className="stats-items-container">
        <StatsItem 
          icon={<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line></svg>}
          title="Product Catalog" 
          value={stats.products} 
          suffix="+"
        />
        <StatsItem 
          icon={<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>}
          title="Vendors" 
          value={stats.merchants} 
        />
        <StatsItem 
          icon={<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>}
          title="Customers" 
          value={stats.customers} 
        />
        <StatsItem 
          icon={<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line></svg>}
          title="Transactions" 
          value={stats.orders} 
        />
      </div>
    </section>
  );
};

export default StatsSection;